<template>
    <div class="custom-table">
        <table class="b-1-gray-40 wp-10">
            <thead>
                <tr>
                    <slot name="header"></slot>
                </tr>
            </thead>
            <tbody>
                <slot name="content"></slot>
            </tbody>
        </table>
    </div>
</template>

<script>
export default {};
</script>

<style lang="scss" scoped>
table {
    background: var(--colors-common-background-default);
    border-radius: 4px;
    text-align: left;
    border-spacing: 0;
    td,
    th {
        border-bottom: 1px solid var(--colors-common-border-default);
        padding: 14px 16px;
    }
    tbody {
        tr:last-child {
            td {
                border: none !important;
            }
        }
    }
}
</style>
